import React, { useEffect, useState } from 'react'
import { Button } from "../../components/ui/buttons/Button"
import { PageHeader } from '../../components/ui/layout/PageHeader'
import { PageContainer } from "../../components/ui/layout/PageContainer"
import { Users } from './pageComponents/Users'
import { GroupControl } from './pageComponents/GroupControl'
import { JobLinks } from './pageComponents/JobLinks'
import { JobAccess } from './pageComponents/JobAccess'
import { TabContainer } from '../../components/ui/tabNavigation/TabContainer'
import { TabButton } from '../../components/ui/tabNavigation/TabButton'

/**
 * Dashboard for Admin users to create/read/update/delete users, groups, job links, and job access
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const AdminDashboard = () => {
    const [activeComponent, setActiveComponent] = useState('Users');

    //render components depending on which button selected
    const componentMap = {
        Users: <Users />,
        GroupControl: <GroupControl />,
        JobLinks: <JobLinks />,
        JobAccess: <JobAccess />,
    };

    useEffect(() => {
        document.title =  `MarTrak - Admin Dashboard`
    }, []);

    return (
        <>
            {/* header */}

            <PageHeader pageTitle="Admin Dashboard"/>

            {/* page content */}

            <PageContainer>

                <TabContainer>

                    <TabButton 
                        onClick={() => setActiveComponent("Users")}
                        isActive={activeComponent === "Users"}
                    >
                            Users
                    </TabButton>

                    <TabButton 
                        onClick={() => setActiveComponent("GroupControl")} 
                        isActive={activeComponent === "GroupControl"}
                    >
                        Group Control
                    </TabButton>

                    <TabButton 
                        onClick={() => setActiveComponent("JobLinks")} 
                        isActive={activeComponent === "JobLinks"}
                    >
                        Job Links
                    </TabButton>

                    <TabButton 
                        onClick={() => setActiveComponent("JobAccess")} 
                        isActive={activeComponent === "JobAccess"}
                    >
                        Job Access
                    </TabButton>

                </TabContainer>

                {/* display component depending on user selection */}
                <div>
                    {componentMap[activeComponent]}
                </div>

            </PageContainer>

        </>
    )
}